import {
    Component,
    Input,
} from '@angular/core';
import {CommonModule, NgClass} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";

@Component({
    selector: 'white-label-copy-link',
    templateUrl: './copy-link.component.html',
    imports: [
        NgClass,
        CommonModule,
        TranslateModule

    ],
    standalone: true,
    providers: [
    ]
})
export class CopyLinkComponent {
    // The link to be copied. You can update this value or bind it dynamically.
    @Input() link: string = 'https://example.com';
    @Input() label: string = '';
    // Flag to show a temporary success message.
    copySuccess: boolean = false;

    // Function to copy the link to the clipboard.
    copyLink(): void {
        navigator.clipboard.writeText(this.link)
            .then(() => {
                this.copySuccess = true;
                // Hide the success message after 2 seconds.
                setTimeout(() => this.copySuccess = false, 2000);
            })
            .catch(err => console.error('Error copying link: ', err));
    }
}

